import { render, staticRenderFns } from "./Colecoes.vue?vue&type=template&id=1ea9eef7&"
import script from "./Colecoes.vue?vue&type=script&lang=js&"
export * from "./Colecoes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports